import { useEffect } from "react";
import { useNetlifySDK } from "../use_netlify_sdk.js";

export const THEME_DARK_MODE_CLASS = "tw-dark";

export enum ThemePreference {
  Light = "light",
  Dark = "dark",
}

export type ThemeProps = {
  children?: React.ReactNode | undefined;
};

export const Theme = ({ children }: ThemeProps) => {
  const sdk = useNetlifySDK();

  useEffect(() => {
    if (sdk.context.theme === ThemePreference.Dark.toString()) {
      document.documentElement.classList.add(THEME_DARK_MODE_CLASS);
    } else {
      document.documentElement.classList.remove(THEME_DARK_MODE_CLASS);
    }
  }, [sdk.context.theme]);

  return <>{children}</>;
};
